import React, { useEffect } from "react";

import { faTriangleExclamation } from "@performyard/fontawesome/pro-solid-svg-icons";
import type { ICohortQueryModel } from "@performyard/models";
import { Spinner, Text, useWizard } from "@performyard/py-components";

import { EmployeeQueryBuilder } from "../../../../../../components/EmployeeQueryBuilder";

import { useEmployeeFields } from "../../../../../../api/hooks";

import { AUTOMATION_RULES_STEP_ID } from "./constants";

const NO_CONDITIONS_BANNER = "At least one condition is required to define subject selection.";

type AutomatedSubjectsStepProps = {
	stepTitle: string;
	autoflowUserQuery: ICohortQueryModel | null;
	onQueryChange: (query: ICohortQueryModel) => void;
};

export const AutomatedSubjectsStep = ({ stepTitle, autoflowUserQuery, onQueryChange }: AutomatedSubjectsStepProps) => {
	const { setStepData, stepsWithErrors, currentStep } = useWizard();
	const { employeeFields, isLoading } = useEmployeeFields();
	const stepHasError = stepsWithErrors.includes(currentStep);

	useEffect(() => {
		setStepData(AUTOMATION_RULES_STEP_ID, { autoflowUserQuery });
	}, [autoflowUserQuery, setStepData]);

	if (isLoading) {
		return (
			<div className="flex min-h-[400px] items-center justify-center">
				<Spinner size={32} />
			</div>
		);
	}

	return (
		<div className="flex flex-col items-center">
			<Text size="sub-heading" weight="semi-bold" color="neutral-9" dangerouslySetClassName="text-center">
				{stepTitle}
			</Text>
			<Text size="paragraph-2" color="neutral-9" dangerouslySetClassName="text-center">
				Automation Rules
			</Text>
			<div className="mt-8 w-full px-4">
				<EmployeeQueryBuilder
					employeeFields={employeeFields}
					value={autoflowUserQuery}
					onChange={onQueryChange}
					enableAnniversary={true}
					fieldSelectPlaceholder="Select a field"
					errorBanner={
						stepHasError ? { message: NO_CONDITIONS_BANNER, icon: faTriangleExclamation } : undefined
					}
				/>
			</div>
		</div>
	);
};
